<template>
	<a class="tab-action"><sym-icon name="more"></sym-icon></a>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
const props = defineProps({});
</script>

<style></style>